<form [formGroup]="exportForm" (ngSubmit)="submit()" class="export-form-container">
  <mat-form-field>
    <input matInput placeholder="Design USA" type="number" min="0"  formControlName="ingCost" i18n-placeholder>
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="Shipping USA" type="number" min="0" formControlName="shipping" i18n-placeholder>
  </mat-form-field>
  <mat-form-field>
    <input class="no-spinner" matInput placeholder="Exchange rate" type="number" min="0" formControlName="exchangeRate" i18n-placeholder>
    <button type="button" mat-icon-button matSuffix (click)="refreshRatio()"><mat-icon>refresh</mat-icon></button>
    <mat-hint>{{ exchangeRateHint }}</mat-hint>
  </mat-form-field>
</form>


// WEBPACK FOOTER //
// ./src/app/budget/components/export-form.component.html